import MotoristaEnderecoService from "@/services/MotoristaEnderecoService";

export const motoristaEndereco = {
  namespaced: true,
  state: {
    motoristaEndereco: {},
  },
  actions: {
    getMotoristaEndereco({ commit }, payload) {
      return MotoristaEnderecoService.GetMotoristaEndereco(payload).then(
        (motoristaEndereco) => {
          return Promise.resolve(motoristaEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postMotoristaEndereco({ commit }, payload) {
      return MotoristaEnderecoService.PostMotoristaEndereco(payload).then(
        (motoristaEndereco) => {
          return Promise.resolve(motoristaEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putMotoristaEndereco({ commit }, payload) {
      return MotoristaEnderecoService.PutMotoristaEndereco(payload).then(
        (motoristaEndereco) => {
          return Promise.resolve(motoristaEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteMotoristaEndereco({ commit }, payload) {
      return MotoristaEnderecoService.DeleteMotoristaEndereco(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getMotoristaEnderecoOData({ commit }, payload) {
      return MotoristaEnderecoService.GetMotoristaEnderecoOData(payload).then(
        (motoristaEndereco) => {
          return Promise.resolve(motoristaEndereco);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default motoristaEndereco;
